import { ReactElement } from 'react';
import { useNavDrawers } from './use-nav-drawer';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';
import { FrNavItem } from './fr-nav-item';

export function UnitLocationNavItem({ label }: { label?: string }): ReactElement {
    const unitAssignment = useUnitAssignment();
    const { isDrawerOpen, toggleDrawer } = useNavDrawers('unit-location', {
        unitId: unitAssignment?.unitId,
    });

    return (
        <FrNavItem
            icon="Location"
            isActive={isDrawerOpen}
            label={label}
            data-testid="unit-location-nav-link-nav"
            style={{ marginBottom: 8 }}
            onClick={toggleDrawer}
        />
    );
}
